export { default } from './EmprestimoGarantiaCarroPorQue';
